import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getItems } from '../../../api/items';

import { mergeItemsListWithUserData } from '../../../utils/items';
import { generateItemCIDKey } from '../../../components/Items/utils/generateItemCIDKey';
import {
  checkAndSetLoading,
  handleRequestRejection,
  matchRequest,
  resetLoading,
} from '../../../utils/asyncThunkRequest';

import { NEXT_LINK } from '../constants/itemsHeaders';

export const fetchItems = createAsyncThunk(
  'items/fetchItems',
  async ({ path, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getItems(path, {
        cancelToken: source.token,
        params,
      });
      const [itemsResponse, userDataMapResponse] = response;

      return {
        data: mergeItemsListWithUserData(itemsResponse, userDataMapResponse),
        nextLink: itemsResponse.headers[NEXT_LINK] || null,
      };
    } catch (error) {
      return rejectWithValue(error.response?.status);
    }
  },
);

export const fetchItemsExtraReducers = builder => {
  builder
    .addCase(fetchItems.pending, (state, action) => {
      checkAndSetLoading(state.items.display.pagination, action);
    })
    .addCase(fetchItems.fulfilled, (state, action) => {
      const { payload } = action;

      if (matchRequest(state.items.display.pagination, action)) {
        payload.data.items.forEach(item => {
          const itemCIDKey = generateItemCIDKey(item);
          state.items.item.byId[itemCIDKey] = item;

          if (!state.items.item.allIds.includes(itemCIDKey))
            state.items.item.allIds.push(itemCIDKey);
        });

        state.items.display.layout.push(...payload.data.layout);
        state.items.display.pagination.next = payload.nextLink;

        resetLoading(state.items.display.pagination);
      }
    })
    .addCase(fetchItems.rejected, (state, action) => {
      handleRequestRejection(state.items.display.pagination, action);
    });
};
